import { render, staticRenderFns } from "./QuestionnaireGlossaryItemSelector.vue?vue&type=template&id=45c697b1&"
import script from "./QuestionnaireGlossaryItemSelector.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireGlossaryItemSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports